// Records that the `rewards_platform` flag has been seen ON. It's a public,
// deployment-global gate — the same value for every user — so once Statsig has
// reported it on, that fact doesn't change when the user logs in.
//
// The early-access gate sets this when it offers the "Continue with X" /
// "Start questing" CTA, which it only does when the flag is on. The rewards gate
// then trusts it instead of re-reading the flag after login — when Statsig
// refetches gate values for the freshly-created account (`updateUserAsync`) and
// momentarily reports every gate as `false`, which used to 404 the user.
//
// sessionStorage so it survives the OAuth full-page redirect (same as
// `X_WAITLIST_SUCCESS_KEY`), and clears with the tab so a future rollback of the
// flag takes effect next session.
const REWARDS_UNLOCKED_KEY = 'morfi_rewards_unlocked';

export function markRewardsUnlocked(): void {
  try {
    window.sessionStorage.setItem(REWARDS_UNLOCKED_KEY, '1');
  } catch {
    // SILENT-CATCH: sessionStorage blocked (private mode) — the rewards gate
    // falls back to reading the live flag, so this is a best-effort fast path.
  }
}

export function readRewardsUnlocked(): boolean {
  try {
    return window.sessionStorage.getItem(REWARDS_UNLOCKED_KEY) === '1';
  } catch {
    // SILENT-CATCH: sessionStorage throws in private mode / when disabled —
    // treat as "not recorded" and let the gate read the live flag.
    return false;
  }
}
